import { render } from "./TesteCargaFormulario.vue?vue&type=template&id=45e74d41&scoped=true"
import script from "./TesteCargaFormulario.vue?vue&type=script&lang=js"
export * from "./TesteCargaFormulario.vue?vue&type=script&lang=js"

import "./TesteCargaFormulario.vue?vue&type=style&index=0&id=45e74d41&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e74d41"]])

export default __exports__